import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Background from './Background';
import ProfileModal from '../Profile/ProfileModal';

const AUTH_PATHS = ['/login', '/register', '/reset-password', '/'];

const PAGE_TITLES = {
  '/login':                        'Connexion — Dub Hub',
  '/register':                     'Inscription — Dub Hub',
  '/reset-password':               'Réinitialisation — Dub Hub',
  '/home':                         'Accueil — Dub Hub',
  '/gestion-budget/dashboard':     'Tableau de bord — Budget',
  '/gestion-budget/transactions':  'Transactions — Budget',
  '/gestion-budget/subscriptions': 'Abonnements — Budget',
  '/gestion-budget/charts':        'Graphiques — Budget',
  '/gestion-bet/recap':            'Récap — Winamax',
  '/gestion-bet/transactions':     'Transactions — Winamax',
  '/gestion-bet/graphiques':       'Graphiques — Winamax',
};

const getInitials = (name) => {
  if (!name) return '?';
  return name.trim().split(/\s+/).map(w => w[0]).join('').toUpperCase().slice(0, 2);
};

const BUDGET_NAV_MOBILE = [
  {
    path: '/gestion-budget/dashboard',
    label: 'Accueil',
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.75" viewBox="0 0 24 24">
        <rect x="3" y="3" width="7" height="7" rx="1.5"/>
        <rect x="14" y="3" width="7" height="7" rx="1.5"/>
        <rect x="3" y="14" width="7" height="7" rx="1.5"/>
        <rect x="14" y="14" width="7" height="7" rx="1.5"/>
      </svg>
    ),
  },
  {
    path: '/gestion-budget/transactions',
    label: 'Transactions',
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.75" viewBox="0 0 24 24">
        <path d="M3 9l4-4 4 4M7 5v14M21 15l-4 4-4-4m4 4V5"/>
      </svg>
    ),
  },
  {
    path: '/gestion-budget/subscriptions',
    label: 'Abonnements',
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.75" viewBox="0 0 24 24">
        <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"/>
        <path d="M12 6v6l4 2"/>
      </svg>
    ),
  },
  {
    path: '/gestion-budget/charts',
    label: 'Graphiques',
    icon: (
      <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.75" viewBox="0 0 24 24">
        <path d="M18 20V10M12 20V4M6 20v-6"/>
      </svg>
    ),
  },
];

const BET_NAV_MOBILE = [
  {
    path: '/gestion-bet/recap',
    label: 'Récap',
    icon: <span style={{ fontSize: 20, lineHeight: 1 }}>▦</span>,
  },
  {
    path: '/gestion-bet/transactions',
    label: 'Transactions',
    icon: <span style={{ fontSize: 20, lineHeight: 1 }}>⇅</span>,
  },
  {
    path: '/gestion-bet/graphiques',
    label: 'Graphiques',
    icon: <span style={{ fontSize: 20, lineHeight: 1 }}>∿</span>,
  },
];

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  const isAuthPage = AUTH_PATHS.includes(location.pathname) && !isAuthenticated;
  const isBet = location.pathname.startsWith('/gestion-bet');
  const isLauncher = location.pathname === '/home';
  const mobileNavItems = isBet ? BET_NAV_MOBILE : BUDGET_NAV_MOBILE;

  useEffect(() => {
    document.title = PAGE_TITLES[location.pathname] ?? 'Dub Hub';
  }, [location.pathname]);

  const bgTheme = 'launcher';

  if (isAuthPage) {
    return (
      <>
        <Background theme="launcher" />
        {children}
      </>
    );
  }

  return (
    <>
      <Background theme={bgTheme} />

      {/* Mobile top bar */}
      <div className="mobile-topbar">
        <button className="mobile-logo" onClick={() => navigate('/home')}>
          <img
            src={isLauncher ? '/dub-hub-logo.svg' : isBet ? '/logo-winamax-gestion.svg' : '/logo-budget-gestion.svg'}
            alt="logo"
            className="mobile-logo-icon"
          />
        </button>
        <button className="mobile-avatar-btn" onClick={() => setShowProfile(true)}>
          {getInitials(user?.name)}
        </button>
      </div>

      <div className="app-shell">
        <Sidebar />
        <main className="main-area">
          {children}
        </main>
      </div>

      {/* Mobile bottom nav */}
      {!isLauncher && (
        <nav className="mobile-nav">
          {mobileNavItems.map(item => (
            <button
              key={item.path}
              className={`mobile-nav-item${location.pathname === item.path ? ' active' : ''}`}
              onClick={() => navigate(item.path)}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      )}

      {showProfile && <ProfileModal onClose={() => setShowProfile(false)} />}
    </>
  );
};

export default Layout;
